export default __webpack_public_path__ + "img/35053784a8966e5804405a813383ab0b.png";